module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sliders"
  }, _vm._l((_vm.sliders), function(slide) {
    return _c('div', {
      staticClass: "slide"
    }, [_c('div', {
      staticClass: "copy"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('h2', [_vm._v(_vm._s(slide.title.value))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(slide.description.value))])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, _vm._l((_vm.sliders), function(slide) {
    return _c('div', [_c('span', {
      class: {
        active: slide.active_year.value.length
      },
      attrs: {
        "id": "gtm_Timeline-Selection"
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(slide.year.value) + "\n\t\t\t")])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42b0abe3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline.vue
// module id = 1518
// module chunks = 0